import { useState } from 'react';

const useVehicleTabs = (defaultTab = 'Territory') => {
    const [selectedTab, setSelectedTab] = useState(defaultTab);

    const handleTabChange = (event, newValue) => {
        setSelectedTab(getTabLabelFromIndex(newValue));
    };

    const getTabLabelFromIndex = (index) => {
        switch (index) {
            case 0:
                return 'Territory';
            case 1:
                return 'Everest';
            case 2:
                return 'Explorer';
            case 3:
                return 'Ranger';
            case 4:
                return 'Transit';
            case 5:
                return 'Mustang';
            default:
                return '';
        }
    };

    const getIndexFromTabLabel = (label) => {
        switch (label) {
            case 'Territory':
                return 0;
            case 'Everest':
                return 1;
            case 'Explorer':
                return 2;
            case 'Ranger':
                return 3;
            case 'Transit':
                return 4;
            case 'Mustang':
                return 5;
            default:
                return 0;
        }
    };

    return {
        selectedTab,
        handleTabChange,
        value: getIndexFromTabLabel(selectedTab),
    };
};

export default useVehicleTabs;